import {
    ORDER_MENU_LOADING, ORDER_MENU_SUCCESS, ORDER_MENU_ERROR
} from "actions/actionOrdersMenu";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "orderMenu";

const initialState = {
    orderMenu: loadState(sessionKey, []),
    loading: false,
    error: ''
};

function reducerOrderMenu(state = initialState, action) {
    switch (action.type) {
        case ORDER_MENU_LOADING: {
            return {
                ...state,
                loading: true,
                error: ''
            };
        }

        case ORDER_MENU_SUCCESS: {

            let orderMenu = [
                ...action.payload
            ]

            saveState(sessionKey, orderMenu);

            return {
                ...state,
                orderMenu: orderMenu,
                loading: false,
                error: ''
            };
        }
        case ORDER_MENU_ERROR: {

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors[0].ErrorMessage
            }
            else
                error = action.error.message;

            saveState(sessionKey, []);

            return {
                ...state,
                orderMenu: [],
                loading: false,
                error: error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerOrderMenu;